import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Button,
  ButtonToolbar,
  Table,
} from "reactstrap";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import TableOperationsDiary from "./TableOperationsDiary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import GenerateExcelReportOperationalDiary from "../ExportFiles/GenerateExcelReportOperationalDiary";
import Spinner from "react-bootstrap/Spinner";
import { MenuItem, TextField } from "@material-ui/core";

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#3EA3FC",
      contrastText: "#fff",
    },
  },
});

const ReportOperationsDiary = ({}) => {
  const [loading, setLoading] = useState(false);
  const [starterDate, setStarterDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dataOperationDiary, setDataOperationDiary] = useState([]);
  const [radiopharmacyDose, setRadiopharmacyDose] = useState([]);
  const [messageAlert, setMessageAlert] = useState("");
  const [errors, setErrors] = useState({});
  const [listHeadquarters, setListHeadquarters] = useState([]);
  const [headquarters, setHeadquarters] = useState("");

  const getHeadquarters = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "sedes/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("sedess", data);

        setListHeadquarters(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDataOperationsDiary = async () => {
    if (validateForm()) return;
    setLoading(true);
    let fechaInicial = moment(starterDate).format("YYYY/MM/DD");
    let fechaFinal = moment(endDate).format("YYYY/MM/DD");
    let dataSend = {
      fecha_inicio: moment(fechaInicial + " " + "00:00:00").format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      fecha_final: moment(fechaFinal + " " + "23:59:59").format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      
      headquarters,
    };
    
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "reportes/diario-operaciones-control-cita",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((dataDiario) => {        
        setDataOperationDiary(dataDiario);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setDataOperationDiary([]);
        setLoading(false);
      });
  };

  const getDataRadiopharmacyDose = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "reportes/consultar-dosis-radiofarmacia",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        setRadiopharmacyDose(data);
        //codeServices(data);
      })
      .catch((error) => {
        console.log(error);
        setRadiopharmacyDose([]);
      });
  };

  useEffect(() => {
    getHeadquarters();
    getDataRadiopharmacyDose();
  }, []);

  useEffect(() => {
    if (listHeadquarters.length > 0 && !headquarters) {
      setHeadquarters(listHeadquarters[0].id_sede);
    }
  }, [listHeadquarters, headquarters]);

  const validateForm = () => {
    let isThereAnError = false;
    let errorInTheForm = {};

    if (starterDate === null) {
      errorInTheForm.starterDate = "Debe Seleccionar una fecha inicial";
      isThereAnError = true;
    }
    if (endDate === null) {
      errorInTheForm.endDate = "Debe Seleccionar una fecha final";
      isThereAnError = true;
    }
    setErrors(errorInTheForm);
    return isThereAnError;
  };  

  return (
    <Fragment>
      <Row className="row-default-space-receipt">
        <Col md={3}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <ThemeProvider theme={defaultMaterialTheme}>
              <KeyboardDatePicker
                style={{ width: "100%", minWidth: "100%", maxWidth: "100%" }}
                value={starterDate}
                variant="inline"
                autoOk={true}
                onChange={(date) => {
                  setStarterDate(date);
                }}
                label="Fecha Inicial"
                format="DD/MM/YYYY"
                animateYearScrolling
                className="medical-material-form__field material-form__label"
                error={
                  errors.hasOwnProperty("starterDate")
                    ? errors.starterDate !== ""
                    : false
                }
                helperText={errors.starterDate}
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Col>
        <Col md={3}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <ThemeProvider theme={defaultMaterialTheme}>
              <KeyboardDatePicker
                style={{ width: "100%", minWidth: "100%", maxWidth: "100%" }}
                value={endDate}
                variant="inline"
                autoOk={true}
                onChange={(date) => {
                  setEndDate(date);
                }}
                label="Fecha Final"
                format="DD/MM/YYYY"
                animateYearScrolling
                className="medical-material-form__field material-form__label"
                error={
                  errors.hasOwnProperty("endDate")
                    ? errors.endDate !== ""
                    : false
                }
                helperText={errors.endDate}
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Col>
        <Col>
          <TextField
            className="material-form__field"
            label="Sede"
            id="id-simple-select"
            //className="material-form__field"
            style={{ width: 300 }}
            select
            value={headquarters}
            onChange={(e) => setHeadquarters(e.target.value)}
          >
            {listHeadquarters.map((headquarter) => {
              return (
                <MenuItem
                  className="material-form__option"
                  key={headquarter.id_sede}
                  value={headquarter.id_sede}
                >
                  {headquarter.nombre}
                </MenuItem>
              );
            })}
          </TextField>
        </Col>
        <Col md={3}>
          <Button
            style={{ marginTop: 10, marginRight: 10 }}
            size="sm"
            variant="contained"
            color="primary"
            onClick={() => {
              getDataOperationsDiary();
              getDataRadiopharmacyDose();
            }}
          >
            Consultar
          </Button>
        </Col>
      </Row>

      {loading == false ? (
        <>
          {dataOperationDiary.length > 0 ? (
            <TableOperationsDiary
              reactTableData={dataOperationDiary}
              radiopharmacyDose={radiopharmacyDose}
              starterDate={starterDate}
              endDate={endDate}
            />
          ) : null}
        </>
      ) : (
        <div className="text-center">
          <Spinner animation="border" variant="success" />
        </div>
      )}
      <div></div>
    </Fragment>
  );
};
export default ReportOperationsDiary;
